const CategoryQuestionsReduser = (state = [], action) => {
    switch (action.type) {
        case 'CATEGORY_QUESTION_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default CategoryQuestionsReduser